import { Portal, svgSprite, zendoStorage } from '../../hybrid/wrappers';
import css from './CustomPasswordModal.module.scss';
import T from '../../common/components/T';
import { useCallback, useContext, useEffect, useState } from 'react';
import UserContext from '../../common/utils/getContext';
import FormComponent from '../../widgets/form/FormComponent/FormComponent';
import { dataSender } from '../../common/utils/router';
import { useRouter } from 'next/router';

export default function CustomPasswordModal() {
    const { lang, userToken } = useContext(UserContext);
    const [data, setData] = useState(null);
    const [isKeyAdded, setIsKeyAdded] = useState(false);
    const router = useRouter();

    useEffect(() => {
        const checkKey = () => {
            if (zendoStorage.get('unauthenticated')) setIsKeyAdded(true);
            else setData(null);
        };
        checkKey();
        const interval = setInterval(checkKey, 500);
        return () => {
            clearInterval(interval);
        };
    }, []);

    useEffect(() => {
        (async () => {
            if (!isKeyAdded) return;
            const unauthData = await JSON.parse(zendoStorage.get('unauthenticated'));
            setData(unauthData);

            const listener = () => {
                zendoStorage.remove('unauthenticated');
            };

            window.addEventListener('beforeunload', listener);
            return () => {
                window.removeEventListener('beforeunload', listener);
            };
        })();
    }, [isKeyAdded, router?.route]);

    const sender = useCallback(
        (dataToSend, setAllowedSend, setFieldsErr) => {
            dataSender(
                data?.auth_route,
                'POST',
                {
                    ...dataToSend,
                    type: data?.type
                },
                () => {
                    zendoStorage.remove('unauthenticated');
                    if (data?.reloadPage) {
                        window.location.reload();
                    }
                    // onSuccess && onSuccess();
                },
                (error) => {
                    if (error?.errors) {
                        setFieldsErr(error?.errors);
                    }
                    setAllowedSend(true);
                },
                userToken,
                lang,
                false
            );
        },
        [userToken, lang, data]
    );
    if (!data) return null;
    return (
        <Portal>
            <div className={css.modal}>
                <div
                    onClick={() => {
                        setData(false);
                        setIsKeyAdded(false);
                        zendoStorage.remove('unauthenticated');
                    }}
                    className={css.close}
                >
                    {svgSprite('cross')}
                </div>
                <div className={css.head}>
                    <p className={css.title}>{data?.type_translated}</p>
                </div>
                <div className={css.body}>
                    <FormComponent
                        data={[
                            {
                                placeholder: '******',
                                attribute: 'password',
                                required: true,
                                title: {
                                    body: <T textName='custom-password-input-title' defaultStr='Пароль' />
                                },
                                type: 'password'
                            }
                        ]}
                        sendData={{ sender }}
                    />
                </div>
            </div>
        </Portal>
    );
}
